module.exports = __webpack_public_path__ + "img/aq.43078901.png";